/**
 * Peshni live Instagram feed.
 *
 * Looks for [data-peshni-instagram-grid] elements that also carry
 * data-instagram-token / data-instagram-user-id (only present when the
 * merchant has filled in both fields in the section's theme settings).
 * When present, fetches the account's real recent media from the
 * Instagram Graph API and swaps them in for the static image_picker
 * blocks. Nothing here is faked: if the settings are empty, or the fetch
 * fails for any reason (expired token, network error, rate limit), the
 * server-rendered static blocks are left exactly as they are — the
 * section never shows a broken or empty state to a customer.
 */
(function () {
  function buildCard(post) {
    var isVideoLike = post.media_type === 'VIDEO' || post.media_type === 'REELS';
    var imageSrc = (isVideoLike && post.thumbnail_url) ? post.thumbnail_url : post.media_url;
    if (!imageSrc) return null;

    var link = document.createElement('a');
    link.href = post.permalink || '#';
    link.className = 'peshni-instagram__item';
    link.target = '_blank';
    link.rel = 'noopener';

    var img = document.createElement('img');
    img.src = imageSrc;
    img.loading = 'lazy';
    img.alt = post.caption ? post.caption.slice(0, 160) : 'Peshni Instagram post';
    link.appendChild(img);

    var badge = document.createElement('span');
    badge.className = 'peshni-instagram__badge';
    badge.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">' +
      '<rect x="3" y="6" width="18" height="14" rx="2"/>' +
      '<path d="M8 6l1.6-2.4A1.8 1.8 0 0 1 11 3h2a1.8 1.8 0 0 1 1.4.6L16 6"/>' +
      '<circle cx="12" cy="13" r="3.6"/></svg>';
    link.appendChild(badge);

    return link;
  }

  function loadFeed(grid) {
    var token = grid.dataset.instagramToken;
    var userId = grid.dataset.instagramUserId;
    var count = parseInt(grid.dataset.instagramCount, 10) || 6;
    if (!token || !userId) return;

    var fields = 'id,caption,media_type,media_url,thumbnail_url,permalink,timestamp';
    var url =
      'https://graph.instagram.com/' + encodeURIComponent(userId) + '/media' +
      '?fields=' + fields +
      '&limit=' + count +
      '&access_token=' + encodeURIComponent(token);

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Instagram API responded with ' + response.status);
        return response.json();
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.data) || data.data.length === 0) {
          throw new Error('Instagram API returned no posts');
        }

        var cards = data.data
          .slice(0, count)
          .map(buildCard)
          .filter(function (card) {
            return card !== null;
          });

        if (cards.length === 0) {
          throw new Error('No renderable Instagram posts in response');
        }

        grid.innerHTML = '';
        cards.forEach(function (card) {
          grid.appendChild(card);
        });
      })
      .catch(function (error) {
        // Leave the server-rendered static blocks in place. Only surface
        // this to merchants/developers working in the theme editor —
        // customers never see a broken section.
        if (window.Shopify && window.Shopify.designMode) {
          console.warn('[Peshni Instagram feed] Falling back to manual posts:', error);
        }
      });
  }

  function init() {
    document.querySelectorAll('[data-peshni-instagram-grid][data-instagram-token]').forEach(loadFeed);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
